module.exports = __webpack_public_path__ + "img/plug-1024-primary.dc18495.svg?v=1791296779994";